import { render, staticRenderFns } from "./OffersHistory.vue?vue&type=template&id=62fdfc8d&scoped=true"
import script from "./OffersHistory.vue?vue&type=script&lang=js"
export * from "./OffersHistory.vue?vue&type=script&lang=js"
import style0 from "./OffersHistory.vue?vue&type=style&index=0&id=62fdfc8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fdfc8d",
  null
  
)

export default component.exports